import { FC, CSSProperties } from 'react';
import { ConfirmDialog } from '@agilelab/plugin-wb-platform';
import { Typography, makeStyles } from '@material-ui/core';
import { useUpdateSystemPrototype } from '../../../hooks/useUpdateSystemPrototype';
import { StatusTransition } from './StatusTransition';
import {
  PrototypeStatus,
  PrototypeStatusBadge,
  SystemPrototype,
} from '@agilelab/plugin-wb-system-prototype-common';

type ChangePrototypeStatusDialogProps = {
  className?: string;
  style?: CSSProperties;
  open: boolean;
  prototype?: SystemPrototype | null;
  newStatus?: PrototypeStatus | null;
  onClose: () => void;
};

const useStyles = makeStyles(
  theme => ({
    content: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(2),
      marginTop: theme.spacing(1),
    },
  }),
  { name: 'ChangePrototypeStatusDialog' },
);
export const ChangePrototypeStatusDialog: FC<
  ChangePrototypeStatusDialogProps
> = ({ open, prototype, newStatus, onClose }) => {
  const { mutate: updateFn, isLoading: updating } = useUpdateSystemPrototype();
  const classes = useStyles();
  if (!prototype || !newStatus) return null;

  const desc = (
    <>
      <Typography>The status of the prototype will be changed:</Typography>
      <div className={classes.content}>
        <PrototypeStatusBadge status={prototype.status} />
        <StatusTransition />
        <PrototypeStatusBadge status={newStatus} />
      </div>
    </>
  );

  return (
    <ConfirmDialog
      inProgress={updating}
      open={open}
      onClose={onClose}
      title="Change Prototype Status?"
      description={desc}
      onConfirm={() =>
        updateFn(
          { id: prototype.id, data: { status: newStatus } },
          {
            onSuccess: () => {
              onClose();
            },
            onError: () => {
              onClose();
            },
          },
        )
      }
    />
  );
};
